var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.065 23.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.141 23.617c10.968 0 16.967-9.087 16.967-16.967 0-.259 0-.516-.017-.772a12.111 12.111 0 0 0 2.975-3.086 11.892 11.892 0 0 1-3.425.939 5.978 5.978 0 0 0 2.622-3.3 11.932 11.932 0 0 1-3.786 1.447 5.969 5.969 0 0 0-10.162 5.439 16.937 16.937 0 0 1-12.29-6.23 5.967 5.967 0 0 0 1.846 7.959 5.913 5.913 0 0 1-2.706-.745v.076a5.965 5.965 0 0 0 4.784 5.845 5.936 5.936 0 0 1-2.693.1 5.971 5.971 0 0 0 5.572 4.142 11.963 11.963 0 0 1-7.406 2.558 12.2 12.2 0 0 1-1.42-.086 16.885 16.885 0 0 0 9.141 2.674"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.283dc355ce2e8e25682152a1ba0f8b5a.svg";
export { ForwardRef as ReactComponent };